(function () {
  'use strict';

  var lang = (document.documentElement.lang || 'en').slice(0, 2).toLowerCase();
  var copy = {
    en: {
      short: 'Orders are dispatched within 2 working days.',
      long: 'Orders are prepared and dispatched from our warehouse in Poland within 2 working days. Transit time is shown separately for the destination country.'
    },
    de: {
      short: 'Bestellungen werden innerhalb von 2 Werktagen versendet.',
      long: 'Bestellungen werden innerhalb von 2 Werktagen in unserem Lager in Polen vorbereitet und versendet. Die Transportzeit wird separat für das Zielland angezeigt.'
    },
    fr: {
      short: 'Les commandes sont expédiées sous 2 jours ouvrés.',
      long: 'Les commandes sont préparées et expédiées depuis notre entrepôt en Pologne sous 2 jours ouvrés. Le délai de transport est indiqué séparément selon le pays de destination.'
    },
    es: {
      short: 'Los pedidos se envían en un plazo máximo de 2 días laborables.',
      long: 'Los pedidos se preparan y envían desde nuestro almacén en Polonia en un plazo máximo de 2 días laborables. El tiempo de transporte se muestra por separado según el país de destino.'
    },
    nl: {
      short: 'Bestellingen worden binnen 2 werkdagen verzonden.',
      long: 'Bestellingen worden binnen 2 werkdagen voorbereid en verzonden vanuit ons magazijn in Polen. De transporttijd wordt apart vermeld voor het land van bestemming.'
    }
  };

  var selected = copy[lang] || copy.en;
  var replacements = [
    [/Orders dispatch within 1[–-]5 business days\./g, selected.short],
    [/Orders are dispatched within 1[–-]5 working days\./g, selected.short],
    [/Bearbeitungszeit 1[–-]5 Werktage\./g, selected.short],
    [/Envoi sous 1[–-]5 jours ouvrables\./g, selected.short],
    [/Salida en 1[–-]5 días laborables\./g, selected.short],
    [/Verwerking binnen 1[–-]5 werkdagen\./g, selected.short],
    [
      /All products are dispatched from our warehouse in accordance with the processing time indicated on the product page\. Typically, this is up to 5 working days; however, during promotional periods, when interest in our products is particularly high, the processing time may be extended\. We appreciate your patience and understanding during these times\./g,
      selected.long
    ],
    [
      /All products are dispatched according to the processing time shown on the product page\. Typically, this is up to 5 working days\. During promotional periods, processing time may be extended due to high order volume\./g,
      selected.long
    ],
    [
      /Alle Produkte werden gemäß der auf der Produktseite angegebenen Bearbeitungszeit aus unserem Lager versendet\. In der Regel beträgt diese bis zu 5 Werktage; während Aktionszeiträumen, wenn das Interesse an unseren Produkten besonders hoch ist, kann sich die Bearbeitungszeit jedoch verlängern\. Wir danken dir für deine Geduld und dein Verständnis\./g,
      selected.long
    ],
    [
      /Tous les produits sont expédiés depuis notre entrepôt conformément au délai de traitement indiqué sur la page produit\. En général, ce délai peut aller jusqu’à 5 jours ouvrés ; toutefois, pendant les périodes promotionnelles, lorsque l’intérêt pour nos produits est particulièrement élevé, le délai de traitement peut être prolongé\. Nous vous remercions pour votre patience et votre compréhension\./g,
      selected.long
    ],
    [
      /Todos los productos se envían desde nuestro almacén de acuerdo con el tiempo de procesamiento indicado en la página del producto\. Normalmente, este plazo es de hasta 5 días laborables; sin embargo, durante periodos promocionales, cuando el interés por nuestros productos es especialmente alto, el tiempo de procesamiento puede ampliarse\. Agradecemos tu paciencia y comprensión\./g,
      selected.long
    ],
    [
      /Alle producten worden vanuit ons magazijn verzonden volgens de verwerkingstijd die op de productpagina staat vermeld\. Meestal is dit maximaal 5 werkdagen; tijdens promotieperiodes, wanneer de belangstelling voor onze producten bijzonder groot is, kan de verwerkingstijd echter langer zijn\. Wij danken je voor je geduld en begrip\./g,
      selected.long
    ]
  ];

  function eligible(node) {
    var parent = node.parentElement;
    if (!parent) return false;
    return !parent.closest('script, style, noscript, textarea');
  }

  function fixNode(node) {
    if (!eligible(node)) return;
    var next = node.nodeValue;
    for (var i = 0; i < replacements.length; i += 1) {
      next = next.replace(replacements[i][0], replacements[i][1]);
    }
    if (next !== node.nodeValue) {
      node.nodeValue = next;
      if (node.parentElement) node.parentElement.setAttribute('data-shappy-shipping-fixed', 'true');
    }
  }

  function updateText(root) {
    if (!root) return;
    if (root.nodeType === 3) { fixNode(root); return; }
    if (root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var node;
    while ((node = walker.nextNode())) fixNode(node);
  }

  function start() {
    updateText(document.body);
    // 02.10.2026: po starcie sprawdzamy tylko fragmenty, które doszły albo zmieniły tekst,
    // zamiast przeszukiwać całą stronę przy każdej zmianie (było: pełny przegląd nawet kilkadziesiąt razy w 12 s).
    var pending = [];
    var queued = false;
    var observer = new MutationObserver(function (list) {
      for (var i = 0; i < list.length; i += 1) {
        var m = list[i];
        if (m.type === 'characterData') pending.push(m.target);
        else for (var j = 0; j < m.addedNodes.length; j += 1) pending.push(m.addedNodes[j]);
      }
      if (queued || !pending.length) return;
      queued = true;
      window.setTimeout(function () {
        queued = false;
        var batch = pending;
        pending = [];
        for (var k = 0; k < batch.length; k += 1) {
          if (batch[k].isConnected) updateText(batch[k]);
        }
      }, 120);
    });
    observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    window.setTimeout(function () { observer.disconnect(); }, 12000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
